import axios from "axios";
import { APIs } from "../../api/APIs";
import SafeairManager from "../../api/SafeairManager";


class UserActivityManager {
  static async getUserNameByCognitoId(userCognitoId: string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.usernameByCognitoId,
      parameters: {
        cognitoId: userCognitoId
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }
}

export default UserActivityManager;
